import { Amplify } from "aws-amplify";
import { AuthUserPoolAndIdentityPoolConfig } from "@aws-amplify/core";

export const cognitoUserPoolConfig =
  process.env.REACT_APP_FAY_APP === "provider"
    ? {
        userPoolId: `${process.env.REACT_APP_PROVIDER_USER_POOL_ID}`,
        userPoolClientId: `${process.env.REACT_APP_PROVIDER_USER_POOL_WEB_CLIENT_ID}`,
      }
    : process.env.REACT_APP_FAY_APP === "client"
      ? {
          userPoolId: `${process.env.REACT_APP_PATIENT_USER_POOL_ID}`,
          userPoolClientId: `${process.env.REACT_APP_PATIENT_USER_POOL_WEB_CLIENT_ID}`,
        }
      : null;

if (!cognitoUserPoolConfig) {
  throw Error("REACT_APP_FAY_APP must be set to 'provider' or 'patient'");
}

export const cognitoIdentityPoolConfig =
  process.env.REACT_APP_FAY_APP === "provider" &&
  process.env.REACT_APP_PROVIDER_IDENTITY_POOL_ID
    ? {
        identityPoolId: `${process.env.REACT_APP_PROVIDER_IDENTITY_POOL_ID}`,
      }
    : process.env.REACT_APP_FAY_APP === "client"
      ? {
          identityPoolId: `${process.env.REACT_APP_PATIENT_IDENTITY_POOL_ID}`,
        }
      : null;

export const cognitoPasswordPolicy =
  process.env.REACT_APP_FAY_APP === "provider"
    ? {
        minLength: 12,
        requireLowercase: true,
        requireNumbers: true,
        requireSymbols: true,
        requireUppercase: true,
      }
    : process.env.REACT_APP_FAY_APP === "client"
      ? {
          minLength: 8,
          requireLowercase: true,
          requireNumbers: true,
          requireSymbols: false,
          requireUppercase: true,
        }
      : {};

if (!cognitoIdentityPoolConfig) {
  throw Error("REACT_APP_FAY_APP must be set to 'provider' or 'patient'");
}

export const configureAuthenticator = () => {
  Amplify.configure(
    {
      Auth: {
        Cognito: {
          ...cognitoUserPoolConfig,
          ...cognitoIdentityPoolConfig,
          passwordFormat: cognitoPasswordPolicy,
        },
      } as AuthUserPoolAndIdentityPoolConfig, // The union type of the user/identity pool isn't importable, so we have to cast a layer up in the config object.
      Storage: {
        S3: {
          bucket: `${process.env.REACT_APP_USER_UPLOADS_BUCKET_NAME}`,
          region: "us-east-1",
        },
      },
    },
    {
      Storage: {
        S3: {
          // Prefix is entirely determined by code that uploads files. See `useFiles`
          prefixResolver: async () => "",
          // defaultAccessLevel is used by Amplify for the default `prefixResolver` and
          // also determines some post-upload behavior. This prevents unwarranted side effects,
          // since we assume all uploads are private by default.
          defaultAccessLevel: "private",
        },
      },
    },
  );
};
